import api from './api';

export const userService = {
  login: async (email, password) => {
    const response = await api.post('/users/login/', { email, password });
    return response.data;
  },

  register: async (userData) => {
    const response = await api.post('/users/register/', userData);
    return response.data;
  },

  getCurrentUser: async () => {
    const response = await api.get('/users/me/');
    return response.data;
  },

  getCredits: async () => {
    const response = await api.get('/users/credits/');
    return response.data;
  },

  updateAPIKeys: async (apiKeys) => {
    const response = await api.post('/users/api-keys/', apiKeys);
    return response.data;
  },

  getAPIKeys: async () => {
    const response = await api.get('/users/api-keys/');
    return response.data;
  },
};
